import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let _cache = null;
let _pricePos = null;

export function useCategories() {
  const [categories, setCategories] = useState(_cache || []);
  const [pricePositioning, setPricePositioning] = useState(_pricePos || []);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    if (_cache && _pricePos) return;
    Promise.all([
      api.get("/categories").then((r) => r.data || []),
      api.get("/categories/price-positioning").then((r) => r.data?.options || []),
    ])
      .then(([cats, pps]) => {
        _cache = cats; _pricePos = pps;
        setCategories(cats); setPricePositioning(pps);
      })
      .finally(() => setLoading(false));
  }, []);

  const refresh = async () => {
    const [cats, pps] = await Promise.all([
      api.get("/categories").then((r) => r.data || []),
      api.get("/categories/price-positioning").then((r) => r.data?.options || []),
    ]);
    _cache = cats; _pricePos = pps;
    setCategories(cats); setPricePositioning(pps);
  };

  return { categories, pricePositioning, loading, refresh };
}
